export default "__VITE_ASSET__de9e40ee__"